import React from 'react';
import styled from 'styled-components';

type Props = {
  percentage: number;
  radius?: number;
  stroke?: number;
  color?: string;
  textSize?: number;
};

const Wrapper = styled.div`
  position: relative;
`;

const ProgressText = styled.div<{
  fontSize?: number;
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${({ fontSize = 20 }) => `font-size: ${fontSize}px;`}
  font-weight: bold;
`;

const RootSVG = styled.svg`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  transform: rotate(-90deg);
`;

const ProgressBackground = styled.circle`
  stroke: #e5e5e5;
  fill: transparent;
  stroke-width: ${(props) => props.strokeWidth};
  r: ${(props) => props.r};
  cx: ${(props) => props.cx};
  cy: ${(props) => props.cy};
`;
const Progress = styled.circle`
  stroke: ${(props) => props.stroke};
  fill: transparent;
  stroke-width: ${(props) => props.strokeWidth};
  stroke-dasharray: ${(props) => props.strokeDasharray};
  stroke-dashoffset: ${(props) => props.strokeDashoffset};
  r: ${(props) => props.r};
  cx: ${(props) => props.cx};
  cy: ${(props) => props.cy};
  transition: all 1s ease;
`;

const CircularProgressBar = ({
  percentage,
  radius = 50,
  stroke = 5,
  color = '#00a23f',
  textSize,
}: Props) => {
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <Wrapper>
      <ProgressText fontSize={textSize}>{Math.round(percentage)}%</ProgressText>
      <RootSVG height={radius * 2} width={radius * 2} data-testid="root-svg">
        <ProgressBackground
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          data-testid="progress-background"
        />
        <Progress
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          data-testid="progress-circle"
        />
      </RootSVG>
    </Wrapper>
  );
};

export default CircularProgressBar;
